export const DRAWER_WIDTH = 256
export const DRAWER_WIDTH_SM = 75
